import { useContext } from 'react';

import {
  ListSubheader,
  alpha,
  Box,
  List,
  styled,
  Button,
  ListItem
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';
import { useTranslation } from 'react-i18next';

import DesignServicesTwoToneIcon from '@mui/icons-material/DesignServicesTwoTone';
import BrightnessLowTwoToneIcon from '@mui/icons-material/BrightnessLowTwoTone';


// const MenuWrapper = styled(Box)(
//   ({ theme }) => `
//   .MuiList-root {
//     padding: ${theme.spacing(1)};

//     & > .MuiList-root {
//       padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
//     }
//   }

//     .MuiListSubheader-root {
//       text-transform: uppercase;
//       font-weight: bold;
//       font-size: ${theme.typography.pxToRem(12)};
//       color: ${theme.colors.alpha.trueWhite[50]};
//       padding: ${theme.spacing(0, 2.5)};
//       line-height: 1.4;
//     }
// `
// );

const MenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      padding: ${theme.spacing(1)};

      & > .MuiList-root {
        padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
      }
    }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.palette.text.secondary};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
  `
);


// const SubMenuWrapper = styled(Box)(
//   ({ theme }) => `
//     .MuiList-root {

//       .MuiListItem-root {
//         padding: 1px 0;

//         .MuiBadge-root {
//           position: absolute;
//           right: ${theme.spacing(3.2)};

//           .MuiBadge-standard {
//             background: ${theme.colors.primary.main};
//             font-size: ${theme.typography.pxToRem(10)};
//             font-weight: bold;
//             text-transform: uppercase;
//             color: ${theme.palette.primary.contrastText};
//           }
//         }
    
//         .MuiButton-root {
//           display: flex;
//             color: ${theme.palette.common.white};

//          background-color: alpha(trueWhite, 0.06);

//           width: 100%;
//           justify-content: flex-start;
//           padding: ${theme.spacing(1.2, 3)};

//           .MuiButton-startIcon,
//           .MuiButton-endIcon {
//             transition: ${theme.transitions.create(['color'])};

//             .MuiSvgIcon-root {
//               font-size: inherit;
//               transition: none;
//             }
//           }

//           .MuiButton-startIcon {
//             color: ${theme.colors.alpha.trueWhite[30]};
//             font-size: ${theme.typography.pxToRem(20)};
          
//             margin-inline-end: ${theme.spacing(1)};

//           }
          
//           .MuiButton-endIcon {
//             color: ${theme.colors.alpha.trueWhite[50]};
//            margin-inline-start: auto;
//             opacity: .8;
//             font-size: ${theme.typography.pxToRem(20)};
//           }

//        &.active,
// &:hover {
//   background-color: ${alpha(theme.palette.primary.main, 0.15)};
//   color: ${theme.palette.common.white};

//   .MuiButton-startIcon,
//   .MuiButton-endIcon {
//     color: ${theme.palette.common.white};
//   }
// }

//         &.Mui-children {
//           flex-direction: column;

//         .MuiBadge-root {
//   position: absolute;
//   inset-inline-end: ${theme.spacing(3.2)};
// }

//         }

//         .MuiCollapse-root {
//           width: 100%;

//           .MuiList-root {
//             padding: ${theme.spacing(1, 0)};
//           }

//           .MuiListItem-root {
//             padding: 1px 0;

//             .MuiButton-root {
//               padding: ${theme.spacing(0.8, 3)};

//               .MuiBadge-root {
//                 right: ${theme.spacing(3.2)};
//               }

//               &:before {
//                 content: ' ';
//                 background: ${theme.colors.alpha.trueWhite[100]};
//                 opacity: 0;
//                 transition: ${theme.transitions.create([
//     'transform',
//     'opacity'
//   ])};
//                 width: 6px;
//                 height: 6px;
//                 transform: scale(0);
//                 transform-origin: center;
//                 border-radius: 20px;
// margin-inline-end: ${theme.spacing(1.8)};
//               }

//               &.active,
//               &:hover {

//                 &:before {
//                   transform: scale(1);
//                   opacity: 1;
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
// `
// );

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      .MuiListItem-root {
        padding: 1px 0;

        .MuiButton-root {
          display: flex;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};

             color: #ffffff;
          background-color: ${
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.common.white, 0.06)
              : alpha(theme.palette.common.black, 0.04)
          };

          .MuiButton-startIcon {
            color: ${theme.palette.text.secondary};
            font-size: ${theme.typography.pxToRem(20)};
            margin-inline-end: ${theme.spacing(1)};
          }

          .MuiButton-endIcon {
            color: ${theme.palette.text.secondary};
            margin-inline-start: auto;
            opacity: 0.8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
            background-color: ${alpha(
              theme.palette.primary.main,
              theme.palette.mode === 'dark' ? 0.25 : 0.15
            )};
            color: ${theme.palette.primary.contrastText};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.palette.primary.contrastText};
            }
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiButton-root {
            padding: ${theme.spacing(0.8, 3)};

            &:before {
              content: '';
              background: ${theme.palette.text.primary};
              opacity: 0;
              width: 6px;
              height: 6px;
              border-radius: 20px;
              margin-inline-end: ${theme.spacing(1.8)};
              transform: scale(0);
              transition: ${theme.transitions.create(['opacity', 'transform'])};
            }

            &.active,
            &:hover {
              &:before {
                transform: scale(1);
                opacity: 1;
              }
            }
          }
        }
      }
    }
  `
);


function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);
  const { t } = useTranslation();

const roles: string[] = JSON.parse(
  sessionStorage.getItem("groups") || "[]"
);
  return (
    <>
      <MenuWrapper>
   
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple

                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/dashboards/crypto"

                >
                  {t("Overview")}
                </Button>
              </ListItem>
            </List>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/Page/faq"
                >
                  {t("FAQ")}
                </Button>
              </ListItem>
            </List>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/Page/specializations"
                >
                  {t("Specializations")}
                </Button>
              </ListItem>
            </List>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/Page/consultations"
                >
                  {t("Consultations")}
                </Button>
              </ListItem>
              </List>
              <List>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/Page/cases"
                >
                  {t("Cases")}
                </Button>
              </ListItem>
              </List>
              <List>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/Page/lawyer"
                >
                  {t("Lawyers")}

                </Button>
              </ListItem>
              </List>
              <List>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/Page/banners"
                >
                  {t("Banners")}
                </Button>
              </ListItem>
              </List>
              <List>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/Page/notifications"
                >
                  {t("Notifications")}
                </Button>
              </ListItem>
            </List>
            {
              roles.includes("Admin") && (
                  <List>
              
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/Page/admin-staff"
                >
                  {t("Admin Staff")}
                </Button>
              </ListItem>
            </List>
              )
            }
          
          </SubMenuWrapper>
        

      </MenuWrapper>
    </>
  );
}

export default SidebarMenu;

